import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { TranslationModule } from '@hdms/shared/feature';
import { ButtonModule, ScrollbarModule, SvgIconModule } from '@hdms/shared/ui-core';

import { HeaderUIUserModule } from '../header-user/header-user.module';

import { HeaderContentSliderComponent } from './header-content-slider.component';

@NgModule({
  declarations: [HeaderContentSliderComponent],
  imports: [
    CommonModule,
    HeaderUIUserModule,
    TranslationModule,
    SvgIconModule,
    ButtonModule,
    TranslationModule,
    CommonModule,
    ScrollbarModule,
    SvgIconModule
  ],
  exports: [HeaderContentSliderComponent]
})
export class HeaderContentSliderModule {}
